<template lang="pug">
  .modal
    .overlay
    .modal-card
      slot
      .modal-foot
        .check_close
          a.fir_btn(@click='$emit("never-modal")') 24시간 보지 않기
          .line
          a.sec_btn(@click='$emit("close-modal")') 닫기
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {},
  methods: {},
  created() {},
};
</script>

<style>
/* Modal */
.modal {
  z-index: 9000;
}
.modal,
.overlay {
  width: 400px;
  height: 600px;
  top: 100px;
  left: 40px;
  position: fixed;
}
.modal-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 400px;
  height: 600px;
  position: absolute;
  text-align: center;
  z-index: 1;
  opacity: 1;
}
.content .swiper .swiper-wrapper {
  height: 500px;
}
.swiper-wrapper .swiper-slide {
  background: none;
}
.swiper-slide img {
  /* border: 1px solid #545454; */
  border-bottom: none;
  border-radius: 10px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  height: 500px;
  border-radius: 10px 10px 0 0;
}
.modal-card .content {
  height: 500px;
}
.modal-foot {
  width: 400px;
  margin-top: 45px;
  justify-content: center;
  height: 40px;
  display: flex;
  justify-content: space-between;
}
.check_close {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-content: center;
  background-color: #f7941e;
  border-radius: 0 0 10px 10px;
  height: 45px;
  border-top: 1px solid #c26a00;
}
.check_close a {
  line-height: 45px;
  font-family: 'Noto Sans Korean', sans-serif;
  font-size: 14px;
  color: #ffffff;
}
.check_close input {
  margin-top: 13px;
  vertical-align: middle;
}
.check_close input[type='checkbox'] {
  width: 13px;
  height: 13px;
}
.check_close input[type='checkbox']:checked {
  background-color: rgb(255 255 255);
  border-color: #b8b8b8;
  color: black;
}
.swiper .swiper-pagination .swiper-pagination-bullet-active {
  background: #f7941e;
  border-radius: 5px;
  width: 22px;
  height: 9px;
  opacity: 1;
}
.swiper-pagination .swiper-pagination-bullet {
  width: 9px;
  height: 9px;
  border: 2px solid #f7941e;
  background: none;
  opacity: 0.6;
}
.swiper .swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  margin-top: -8px;
  left: 5px;
  background-image: url('../../assets/images/prev.png');
}
.swiper .swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  margin-top: -8px;
  right: 5px;
  background-image: url('../../assets/images/next.png');
}
.fir_btn {
  width: 160px;
}
.sec_btn {
  width: 100px;
}
.modal-con {
  display: flex;
  flex-direction: row;
}
.line {
  border-left: 1px solid #c26a00;
}
:root {
  --swiper-navigation-size: 0 !important;
}
@media (max-width: 1024px) {
}
@media (max-width: 768px) {
  .line {
    border-left: 2px solid #979797;
    height: 25px;
    margin-top: 10px;
  }
  .check_close {
    border: 0 !important;
    background-color: unset;
  }
  .check_close a {
    color: #c5c5c5 !important;
  }
  .swiper-wrapper .swiper-slide img {
    border: 0;
    border-radius: 10px;
    height: 350px;
  }
  .swiper-pagination .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border: 0;
    border-radius: 100%;
    background: #000;
    opacity: 0.2;
  }
  .modal-card .content {
    height: 400px;
  }
  .content .swiper .swiper-wrapper {
    /* margin-top: 30px; */
    height: 350px;
    top: 25px;
  }
  .modal-foot {
    z-index: 1;
    width: 350px;
    margin-top: -15px;
  }
  .modal-card {
    width: 350px;
    height: 400px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .modal,
  .overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
  }
  .overlay {
    opacity: 0.7;
    background-color: black;
  }
  .swiper .swiper-pagination .swiper-pagination-bullet-active {
    background: #f7941e;
    border-radius: 5px;
    width: 18px;
    height: 6px;
    opacity: 1;
  }
  .swiper-pagination .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background: #d6d6d6;
    opacity: 0.7;
  }
}
</style>
